/**
 * Trial Usage Widget — shows during the 3-day trial.
 * Renders nothing for paid/expired users.
 * © 2026 A-1 Affiliate Marketing LLC
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import './TrialUsageWidget.css';

export const TrialUsageWidget = ({ tierStatus }) => {
  const { t } = useTranslation();
  if (!tierStatus || !tierStatus.is_trial) return null;

  const { trial_day, queries_used, daily_limit, queries_remaining } = tierStatus;

  if (trial_day === 4 || tierStatus.tier === 'trial_expired') {
    return (
      <div className="trial-widget trial-expired" data-testid="trial-widget-expired">
        <div className="tw-title">⏰ {t('trial.expired_title')}</div>
        <div className="tw-sub">{t('trial.expired_sub')}</div>
        <a href="/pricing" className="tw-cta" data-testid="trial-widget-cta">
          {t('trial.choose_plan')}
        </a>
      </div>
    );
  }

  const pct = daily_limit > 0 ? Math.min(100, Math.round((queries_used / daily_limit) * 100)) : 0;
  const danger = queries_remaining <= 1;

  return (
    <div className={`trial-widget ${danger ? 'danger' : ''}`} data-testid="trial-widget">
      <div className="tw-row">
        <span className="tw-day" data-testid="trial-widget-day">
          {t('trial.day_of', { day: trial_day })}
        </span>
        <span className="tw-count" data-testid="trial-widget-count">
          {t('trial.queries_used', { used: queries_used, limit: daily_limit })}
        </span>
      </div>
      <div className="tw-bar" role="progressbar" aria-valuenow={pct} aria-valuemin="0" aria-valuemax="100">
        <div className="tw-fill" style={{ width: `${pct}%` }} data-testid="trial-widget-fill" />
      </div>
      <div className="tw-row tw-foot">
        <span className="tw-remaining">
          {queries_remaining > 0
            ? t('trial.left_today', { remaining: queries_remaining })
            : t('trial.none_left')}
        </span>
        <a href="/pricing" className="tw-link" data-testid="trial-widget-upgrade">
          {t('trial.lock_in_plan')}
        </a>
      </div>
    </div>
  );
};

export default TrialUsageWidget;
